import SetPassword from 'app/modules/auth/views/SetPassword';

function SetPasswordPage() {
  return <SetPassword />;
}

export default SetPasswordPage;
